Ext.define('SA.VectorMapExportTextLabelOverlay', {
    alias: 'widget.vector-map-export-text-label-overlay',
    extend: 'Ext.Component',

    autoShow: true,
    cls: 'sa-vector-map-export-overlay',
    constrain: true,
    draggable: true,
    floating: true,
    overCls: 'sa-vector-map-export-overlay-over',
    toFrontOnShow: false,

    initEvents() {
        this.callParent();

        this.mon(this.getRecord(), 'set:background', this.refresh, this);
        this.mon(this.getRecord(), 'set:color', this.refresh, this);
        this.mon(this.getRecord(), 'set:size', this.refresh, this);
        this.mon(this.getRecord(), 'set:style', this.refresh, this);
        this.mon(this.getRecord(), 'set:text', this.refresh, this);
        this.mon(this.getRecord(), 'set:typeface', this.refresh, this);
    },

    afterRender() {
        this.callParent();

        this.getEl().addClsOnClick('sa-vector-map-export-overlay-drag');
    },

    getRecord() {
        return this.record;
    },

    refresh() {
        var params = SA.VectorMapExportParams.forTextLabel({details: this.details, record: this.record});

        this.svg?.remove();
        this.svg = this.getEl().dom.appendChild(SA.VectorMapExportTextLabel.getSvg(params));

        SA.Svg.setAttr(this.svg, 'width', SA.Svg.getRect(this.svg).width * this.page.getWidth() / this.details.getWidth());
        SA.Svg.setAttr(this.svg, 'height', SA.Svg.getRect(this.svg).height * this.page.getHeight() / this.details.getHeight());
    }
});